export interface PushNotification {
  id: string;
  title: string;
  description: string;
  type: NotificationType;
  target: NotificationTarget;
  timestamp: number;
  metadata: Record<string, any>;
  read: boolean;
}

export type NotificationTarget = {
  type: 'USER' | 'GROUP' | 'ALL';
  value: string;
};

export enum NotificationType {
  CASE_ASSIGNMENT_REQUIRED = 'CASE_ASSIGNMENT_REQUIRED',
  CASE_DONE_REQUIRED = 'CASE_DONE_REQUIRED',
  MAKER_CHECKER_REQUEST = 'MAKER_CHECKER_REQUEST',
}
